/**
 * Created by slava on 4/3/20
 */

const CardTableView = cc.Node.extend({
    notResizable: true,

    ctor: function (table) {
        this._super();

        this.table = table;
        this.centerNode = new cc.Node();
        this.addChild(this.centerNode);
        this.setAnchorPoint(0.5, 0.5);

        this.debugId = "CardTable";

        this.table.on("replaceCardWithAnother", this.replaceCardWithAnother.bind(this));
        this.table.on("insertCard", this.insertCard.bind(this));
        this.table.on("demonstrateBoosterBefore", this.demonstrateBoosterBefore.bind(this));
        this.table.on("resetCards", this.createCards.bind(this));
        this.table.on("animatedChangeSize", this.onTableAnimatedChangeSize.bind(this));
        this.table.on("changeSize", this.onTableChangeSize.bind(this));
        this.table.on("blowCards", this.blowCards.bind(this));
        this.table.on("shuffle", this.shuffle.bind(this));

        this.table.getView = function () {
            return this.centerNode;
        }.bind(this);

        this.createCards();
        this.centerNode.children.forEach((cardView) => {
            cardView.setVisible(false);
        });
    },

    shuffle: function () {
        const cardViews = this.table.cards.map((card) => card.onGetView());

        cleverapps.UI.animateShuffle(cardViews, function () {
            this.setLocalZOrder(this.card.getZ());
        });
    },

    updateTableSize: function () {
        this.calcRect();
        this.setContentSize2(this.rect.width, this.rect.height);
        this.centerNode.setPosition(this.getCenterNodePosition());
    },

    onTableChangeSize: function () {
        this.updateTableSize();
        this.setTableScale();
    },

    onTableAnimatedChangeSize: function () {
        this.calcRect(); 
        const newCenterNodePosition = this.getCenterNodePosition();
        const deltaPos = cc.pSub(newCenterNodePosition, this.centerNode.getPosition());
        const deltaSize = cc.size(this.rect.width - this.width, this.rect.height - this.height);

        this.animateOffset = cc.p(deltaPos.x / 2, deltaPos.y / 2);
        this.animateOffset.x -= deltaSize.width / 2 - deltaPos.x / 2;
        this.animateOffset.y -= deltaSize.height / 2 - deltaPos.y / 2;

        this.centerNode.runAction(new cc.Sequence(
            new cc.MoveBy(0.3, this.animateOffset.x, this.animateOffset.y),
            new cc.CallFunc(() => {
                this.animateOffset = cc.p(0, 0);
                this.setContentSize2(this.rect.width, this.rect.height);
                this.centerNode.setPosition(this.getCenterNodePosition());
            })
        ));

        this.animateTableScale();
    },

    getCenterNodePosition: function () {
        return cc.p(this.rect.width / 2 - this.centerNodeOffset.x, this.rect.height / 2 - this.centerNodeOffset.y);
    },

    setTableScale: function () {
        if (typeof FakeGame !== "undefined" && Game.currentGame instanceof FakeGame) {
            return;
        }
        cleverapps.UI.inflateToBoundaries(this, this.getOverlappingNodes(), {
            maxScale: TileTable.MAX_SCALE,
            padding: cleverapps.styles.CardTableView.padding
        });
    },

    animateTableScale: function () {
        const oldScale = this.scale;
        const oldPosition = this.getPosition();
        const oldSize = this.getContentSize();

        this.setContentSize(this.rect.width, this.rect.height);

        cleverapps.UI.inflateToBoundaries(this, this.getOverlappingNodes(), {
            maxScale: TileTable.MAX_SCALE,
            padding: cleverapps.styles.CardTableView.padding
        });

        this.newScale = this.scale;
        this.newPosition = this.getPosition();

        this.setContentSize(oldSize);
        this.setScale(oldScale);
        this.setPosition(oldPosition);

        this.stopAllActions();
        this.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.ScaleTo(0.3, this.newScale),
                new cc.MoveTo(0.3, this.newPosition)
            ),
            new cc.CallFunc(() => {
                this.setContentSize(this.rect.width, this.rect.height);
            })
        ));
    },

    getOverlappingNodes: function () {
        return cleverapps.Scenes.GetSceneComponent(TileGameSceneComponent).getOverlappingNodes();
    },

    calcRect: function () {
        const rect = this.table.rect;
        this.rect = cc.rect(
            rect.x * resolutionScale,
            rect.y * resolutionScale,
            rect.width * resolutionScale,
            rect.height * resolutionScale
        );
        this.centerNodeOffset = cc.rectGetCenter(this.rect);
        return this.rect;
    },

    createCards: function () {
        this.centerNode.removeAllChildren();

        this.table.cards.forEach(function (card, index) {
            const cardView = CardView.createCardView(card);
            this.centerNode.addChild(cardView);
            cardView.setLocalZOrder(index);
            cardView.setAlignment(card.getViewPosition().point);
        }, this);
    },

    replaceCardWithAnother: function (targetCard, sourceCard) {
        const targetView = targetCard.onGetView();

        const ViewClass = sourceCard.getViewClass();
        const sourceView = new ViewClass(sourceCard);

        sourceView.setLocalZOrder(targetView.getLocalZOrder());
        sourceView.setAlignment(targetView.getPosition());

        targetView.removeFromParent();

        this.centerNode.addChild(sourceView);
    },

    convertToViewPosition: function (modelPosition) {
        return {
            x: modelPosition.x * resolutionScale,
            y: modelPosition.y * resolutionScale
        };
    },

    insertCard: function (card, initialOffset) {
        cleverapps.effects.fire("tile3.joker.appear");

        const cardView = CardView.createCardView(card);
        cardView.setAlignment({
            x: (initialOffset || 0),
            y: 0
        });
        cardView.setRotation(0);
        this.centerNode.addChild(cardView);

        cardView.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode());
        cardView.animation.setAnimation(0, "under_card_start", false);
        cardView.animation.setCompleteListener(() => {
            cardView.animation.setCompleteListener();

            let position = this.convertToViewPosition(card);

            position = cleverapps.Scenes.GetMovingNode().convertToNodeSpace(this.centerNode.convertToWorldSpace(position));

            cardView.animation.setAnimation(0, "under_card_move", false);

            cardView.runAction(
                new cc.Sequence(
                    new cc.Spawn(new cc.MoveTo(0.2, position), new cc.RotateTo(0.2, card.getRotation())),
                    new cc.DelayTime(0.09),
                    new cc.CallFunc(() => {
                        cardView.replaceParentSamePlace(this.centerNode);

                        cardView.setLocalZOrder(card.getZ());
                    })
                )
            );
        });
    },

    demonstrateBoosterBefore: function (boosterCard, callback) {
        const flyingMagnet = new cleverapps.Spine(bundles.boosters_before_game.jsons.boost_magnit_json);
        flyingMagnet.setAnimation(0, "boost_magnit", false);
        flyingMagnet.setPosition({
            x: this.width / 2,
            y: 0
        });
        flyingMagnet.setLocalZOrder(100);
        flyingMagnet.setCompleteListenerRemove(() => {
            cleverapps.effects.fire("solitaire.decorator.appear");
            callback();
        });
        this.addChild(flyingMagnet);

        const targetPosition = this.convertToNodeSpace(boosterCard.onGetView().convertToWorldSpace(cleverapps.styles.MarkView.magnet));
        flyingMagnet.runAction(new cc.Spawn(
            new cc.MoveTo(0.9, targetPosition).easing(cc.easeExponentialInOut()),
            new cc.RotateTo(0.9, boosterCard.r)
        ));

        cleverapps.effects.fire("tile3.magnet.appear");
    },

    blowCards: function (group, callback) {
        const styles = cleverapps.styles.CardTableView.blowCard;
        const scene = cleverapps.Scenes.GetRunningScene();
        const vacuum = new cleverapps.Spine(bundles.booster_effects.jsons.vacuum_json);
        vacuum.setAnimation(0, "animation", false);
        vacuum.setAlignment(scene.width / 2, scene.height / 2);

        const stick = new cleverapps.Spine(bundles.booster_effects.jsons.vacuum_stick_json);
        stick.setAnimation(0, "animation", false);
        stick.setAlignment(styles.stick);
        stick.setCompleteListenerRemove(callback);

        scene.addChild(vacuum);
        scene.addChild(stick);

        cleverapps.effects.fire("tile3.booster.vacuum");

        group.sort((a, b) => b.onGetView().getLocalZOrder() - a.onGetView().getLocalZOrder());

        const targetPosition = cleverapps.Scenes.GetMovingNode().convertToNodeSpace(scene.convertToWorldSpace(stick.getPosition()));
        targetPosition.x += styles.target.dx;
        targetPosition.y += styles.target.dy;

        const distances = group.map((card) => cc.pDistance(this.convertToWorldSpace(card.onGetView().getPosition()), targetPosition));
        const blowingTime = 1.5;
        const maxDistance = Math.max.apply(null, distances);
        const speed = maxDistance / blowingTime;

        vacuum.setCompleteListenerRemove(() => {
            group.forEach((card, i) => {
                const plateOnCard = card.findComponent(PlateOnCard);
                if (plateOnCard) {
                    plateOnCard.collect();
                }
                let delay = (blowingTime * distances[i]) / maxDistance;
                const moveTime = distances[i] / speed;
                const tremDuratin = 0.3;
                delay = Math.max(delay - tremDuratin, 0);
                const cardView = card.onGetView();

                cardView.runAction(new cc.Sequence(
                    new cc.DelayTime(delay),
                    new cc.RotateTo(tremDuratin / 3, -5).easing(cc.easeIn(2)),
                    new cc.RotateTo(tremDuratin / 6, 5),
                    new cc.RotateTo(tremDuratin / 6, -5),
                    new cc.RotateTo(tremDuratin / 3, 0),
                    new cc.Spawn(
                        new cc.Sequence(
                            new cc.CallFunc(() => {
                                if (!card.isOpen()) {
                                    card.flip();
                                }
                                cardView.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(), { keepScale: true });
                            }),
                            new cc.MoveTo(moveTime, targetPosition).easing(cc.easeIn(4)),
                            new cc.RemoveSelf()
                        ),
                        new cc.RotateTo(0.5, 10)
                    )

                ));
            });
        });
    }
});

cleverapps.styles.CardTableView = {
    blowCard: {
        stick: {
            x: { align: "right" },
            y: { align: "center" }
        },
        target: {
            dx: -10,
            dy: 30
        }
    },
    padding: {
        top: 50,
        bottom: 50,
        left: 10,
        right: 10
    }
};